<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <DIV
    :key="index"
    class="d-flex flex-col form-row"
    v-for="(item, index) in items"
  >
    <div
      class="col-auto"
      v-if="items.length > 1"
    >
      #{{ index+1 }}
    </div>
    <div
      class="col"
    >
      <DIV
        class="mb-2"
      >
        <ItpFormInput
          name="name"
          v-model="item.name"
          required
          :readonly="readonly"
        >
        </ItpFormInput>
      </DIV>
      <DIV
        class="form-row align-items-center"
      >
        <div
          class="col-auto"
        >
          <ItpFormCheckbox
            name="include_period"
            v-model="item.include_period"
            :readonly="readonly"
            :label="'Include period'|pgettext('ContractServiceItemNameEditor')"
            class="form-check form-check-inline"
          >
          </ItpFormCheckbox>
        </div>
        <div
          class="col"
        >
          <ItpFormSelect
            name="period_format"
            v-model="item.period_format"
            :options="periodFormats"
            :readonly="readonly"
            valueField="value"
            textField="name"
            null-option
            :disabled="!item.include_period"
          >
          </ItpFormSelect>
        </div>
        <div
          class="col-auto"
        >
          <ItpFormSelect
            name="language"
            v-model="item.language"
            :options="languages"
            :readonly="readonly"
            valueField="value"
            textField="name"
            null-option
            :disabled="!item.include_period"
          >
          </ItpFormSelect>
        </div>
      </DIV>
      <hr
        class="w-25"
        v-if="index != items.length -1"
      >
      </hr>
    </div>
    <div
      class="col-auto"
      v-if="!readonly && !disabled"
    >
      <button
        data-dismiss="modal"
        aria-label="Close"
        :title="'Remove name'|pgettext('ContractServiceItemNameEditor')"
        class="close"
        @click.prevent.stop="evh_4207795475682514_clickPreventStop($event, {item, index})"
      >
        <span aria-hidden="true">&times;</span>

      </button>
    </div>
  </DIV>
  <DIV
    class="d-flex mt-2 align-items-center"
    v-if="!readonly && !disabled"
  >
    <DIV
      class="col-auto"
      @click.prevent.stop="evh_1040167445267876_clickPreventStop($event, {})"
    >
      <ItpLink
        :icon="$config.addIcon"
        :text="'Add name'|pgettext('ContractServiceItemNameEditor')"
      >
      </ItpLink>
    </DIV>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UCContractServiceItemNameEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getItems(...args: any[]) {
    const value = this.value;

    if (this._items && value === this._items) {
      return this._items;
    }

    if (value == null || value.length == 0) {
      this._items = [];
      this.$emit('input', this._items);
      return this._items;
    }

    this._items = value;
    return value
  }

  addItem(...args: any[]) {
    this.items.push(this.newItem())
    this._items = this.items.slice();
    this.items = this._items;
    this.$emit('input', this._items);
  }

  newItem(...args: any[]) {
    return {
      name: null,
      include_period: null,
      period_format: null,
      language: null
    }
  }

  removeItem(...args: any[]) {
    const [item] = args;

    console.log('removeItem', item, _.indexOf(this._items));

    const removed = _.remove(this._items, p => p === item);
    if (removed && removed.length) {
      this._items = this.items.slice();
      this.items = this._items;
      this.$emit('input', this._items);
    }
  }

  @Prop({
    required: true,
    type: Array,
  })
  value!: array;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  @Prop({
    type: Boolean,
  })
  disabled!: boolean;

  @Watch('disabled')
  onDisabled(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("disabled")
  }

  periodFormats!: any;

  async $$load_periodFormats() {
    return this.$app.repo.get('ui_metadata', { path: 'billing_period_formats' })
  }

  languages!: any;
  items!: any;

  async $$load_items() {
    return this.getItems()
  }

  ux!: any;
  dataMembers = ['periodFormats', 'languages', 'items', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        periodFormats: null,
        languages: [{
          value: "hu",
          name: this.$fn.pgettext("languages", "hungarian"),
        }
          ,
        {
          value: "it",
          name: this.$fn.pgettext("languages", "italian"),
        }
          ,
        {
          value: "en",
          name: this.$fn.pgettext("languages", "english"),
        }
          ,
        ]
        ,
        items: null,
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_4207795475682514_script_8918_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4207795475682514_script_8918, alias=undefined
    this.removeItem($event.scope.item)
  }

  async act_4207795475682514_script_8918_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4207795475682514_script_8918, alias=undefined
    return {
      value: () => this.act_4207795475682514_script_8918_getActionArgs_value($event),
    }
  }

  async evh_4207795475682514_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4207795475682514_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_script_8920_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1040167445267876_script_8920, alias=addItem
    this.addItem()
  }

  async act_1040167445267876_script_8920_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1040167445267876_script_8920, alias=addItem
    return {
      value: () => this.act_1040167445267876_script_8920_getActionArgs_value($event),
    }
  }

  async evh_1040167445267876_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8916: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8915: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_4207795475682514_script_8918: actions.ScriptAction;
    evh_4207795475682514_clickPreventStop_8917: actions.EventHandlerImpl;
    evh_4207795475682514_clickPreventStop: actions.EventHandlerGroup;
    act_1040167445267876_script_8920: actions.ScriptAction;
    evh_1040167445267876_clickPreventStop_8919: actions.EventHandlerImpl;
    evh_1040167445267876_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8916 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8915 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8916,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8915],
      }
    );
    const act_4207795475682514_script_8918 = new actions.ScriptAction(
      {
        actionArgs: this.act_4207795475682514_script_8918_getActionArgs,
        events: [],
      }
    );
    const evh_4207795475682514_clickPreventStop_8917 = new actions.EventHandlerImpl(
      {
        action: act_4207795475682514_script_8918,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_4207795475682514_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_4207795475682514_clickPreventStop_8917],
      }
    );
    const act_1040167445267876_script_8920 = new actions.ScriptAction(
      {
        actionArgs: this.act_1040167445267876_script_8920_getActionArgs,
        displayName: "addItem",
        events: [],
      }
    );
    const evh_1040167445267876_clickPreventStop_8919 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_script_8920,
        event: "click.prevent.stop",
        displayName: "addItem",
      }
    );
    const evh_1040167445267876_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_clickPreventStop_8919],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8916,
      evh_7315092382398562_reload_8915,
      evh_7315092382398562_reload,
      act_4207795475682514_script_8918,
      evh_4207795475682514_clickPreventStop_8917,
      evh_4207795475682514_clickPreventStop,
      act_1040167445267876_script_8920,
      evh_1040167445267876_clickPreventStop_8919,
      evh_1040167445267876_clickPreventStop,
      addItem: act_1040167445267876_script_8920,
    }
  }
}

Vue.component("UCContractServiceItemNameEditor", UCContractServiceItemNameEditor);

</script>